import React, { useEffect, useRef } from 'react';
import {
  Tabs,
  Tab,
  Button,
  FormControlLabel,
  Modal,
  DialogTitle,
  IconButton,
  Chip,
  Switch,
  Skeleton,
  Grid,
  Alert,
  Typography,
  Fade
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ExploreIcon from '@mui/icons-material/Explore';
import { styled } from '@mui/material/styles';
import { Box, height, width } from '@mui/system';
import PropTypes from 'prop-types';
import FedExLogo from '../../assets/carrier logos/fedex.png';
import FedExExpressLogo from '../../assets/carrier logos/fedexExpress.png';
import FedExPriLogo from '../../assets/carrier logos/fedex-priority.png';
import ABFLogo from '../../assets/carrier logos/ABFS.png';
import EXLALogo from '../../assets/carrier logos/EXLA.png';
import PITOHIO from '../../assets/carrier logos/PITD.png';
import CTLogo from '../../assets/carrier logos/central-transport.png';
import PYLELogo from '../../assets/carrier logos/PYLE.png';
import YRCLogo from '../../assets/carrier logos/RDWY.png';
import RLLogo from '../../assets/carrier logos/RLcarriers.png';
import WardLogo from '../../assets/carrier logos/WARD.png';
import AACTLogo from '../../assets/carrier logos/AACT.png';
import AVERITTLogo from '../../assets/carrier logos/AVRT.png';
import GLSLogo from '../../assets/carrier logos/GLS.png';
import SMTLLogo from '../../assets/carrier logos/smtl.png';
import USRoadQuoteRate from '../../assets/carrier logos/USRoadQuoteRate.png';
import DaytonCarrierLogo from '../../assets/carrier logos/dayton-freight.png';
import DayLightCarrierLogo from '../../assets/carrier logos/daylight-transport.png';
import NEWPENLogo from '../../assets/carrier logos/New Penn.png';
import UPSLogo from '../../assets/carrier logos/Tfroce freight.png';
import UPSOldLogo from '../../assets/carrier logos/ups.png';
import ODFLlogo from '../../assets/carrier logos/ODFL.png';
import SEFLlogo from '../../assets/carrier logos/Southeastern freight lines.png';
import ReddawayLogo from '../../assets/carrier logos/Reddaway.png';
import SAIALogo from '../../assets/carrier logos/SAIA.png';
import CNWYLogo from '../../assets/carrier logos/CNWY.png';
import GuaranteeIcon from '../../assets/guaranteed.svg';
import { useSelector } from 'react-redux';
import { GetActiveCarriers } from '../../apis/Agency';
import { useState } from 'react';
import axios from 'axios';
import { base_logo_url, base_url } from '../../apis/constants';
import { Row, Col } from 'reactstrap';
import { tooltipClasses } from '@mui/material/Tooltip';
import SortIcon from '@mui/icons-material/Sort';
import './KanbanCss.css';
import { Tooltip } from '@mui/material';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { ToastContainer } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { CircularProgress, Stack } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
function GetShipmentRates(props) {
  const [callCount, setCallCount] = useState(0);
  const isMobile = useIsMobile();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const selectedIndex = props?.selectedIndex;
  const ReloadQuote = props.ReloadQuote;
  const setReloadQuote = props.setReloadQuote;
  const quoteType = props?.quote;
  const obj = props.state;
  const deepCloneObj = props.deepClone;
  const totalWeightLBS = props.totalLBSWeight;
  const SelectedRowData = props.DataToShow;
  const handleListItemClick = props.handleListItemClick;
  const checkAllCarriersRates = props.checkAllCarriersRates;
  const [EstesApiLoading, setEstesApiLoading] = useState(false);
  const [GetRatesArray, setGetRatesArray] = useState([]);
  const [GetRateStandarArray, SetGetRateStandarArray] = useState([]);
  const [GetRateGuaranteedArray, SetGetRateGuaranteedArray] = useState([]);
  const [GetRateQuickDeliveryArray, setGetRateQuickDeliveryArray] = useState(
    []
  );
  const [finalCarrierApis, setFinalCarrierApis] = useState([]);
  const [noActiveCarrier, setNoActiveCarrier] = useState(false);
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [data, setData] = useState([]);
  const [errorMessageApi, setErrorMessageApi] = useState([]);
  const [successRates, setSuccessRates] = useState([]);
  const [rateUniqueId, setRateUniqueId] = useState(0);
  const [checked, setChecked] = useState(false);
  const [filterKey, setFilterKey] = useState('*');
  const [sortKey, setSortKey] = useState('price');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [lowestCostCarrier, setLowestCostCarrier] = useState(null);
  const [quickestCarrier, setQuickestCarrier] = useState(null);
  const [detailModal, setDetailModal] = useState(false);
  const [terminalModal, setTerminalModal] = useState(false);
  const [filterValue, setFilterValue] = useState(0);
  const [sortValue, setSortValue] = useState(0);
  const [currentRate, setCurrentRate] = useState({});
  const accessorialDescriptions = [
    'Inside Pickup',
    'Inside Delivery',
    'Lift Gate Pickup',
    'Lift Gate Delivery',
    'Residential Pickup',
    'Residential Delivery',
    'Secure Access Pickup',
    'Secure Access Delivery',
    'Limited Access Pickup',
    'Limited Access Delivery',
    'Freeze Protection',
    'Overlength',
    'Hazardous Material',
    'Additional Charges',
    'Declared Value',
    'Call Before Delivery',
    'COD Fee',
    'Miscellaneous Charges'
  ];

  const baseRateDescrptions = [
    'Base Rate',
    'Discount %',
    'Discount Value',
    'Line Haul',
    'Fuel Surcharge %',
    'Fuel Surcharge Value',
    'Surcharge'
  ];
  useEffect(() => {
    CallCarrierRatesApi();
  }, [ReloadQuote]);

  useEffect(() => {
    setEstesApiLoading(true);
    fetchData();
  }, [finalCarrierApis]);

  const handleShowHideErrosChnage = event => {
    setChecked(event.target.checked);
  };
  // useEffect(() => {
  //   setChecked(checkedProp);
  // }, [checkedProp]);
  const LoadingArray = [
    { item: 1 },
    { item: 1 },
    { item: 1 },
    { item: 1 },
    { item: 1 }
  ];

  const handleAllCarrierRates = validResults => {
    var temp = [];
    if (validResults?.length > 1) {
    }
    for (let i = 0; i < validResults?.length; i++) {
      setEstesApiLoading(false);
      const ShipArray = validResults;
      const originDetail = ShipArray[i]?.originDetail.contactAndAddress;
      const destinationDetail =
        ShipArray[i]?.destinationDetail.contactAndAddress;
      const originTerminalInfo = ShipArray[i]?.originTerminal.contactAndAddress;
      const destinationTerminalInfo =
        ShipArray[i]?.destinationTerminal.contactAndAddress;

      temp.push({
        carrierID: ShipArray[i]?.carrierInfo.id,
        carrierName: ShipArray[i]?.carrierInfo.name,
        serviceType: ShipArray[i]?.serviceType,
        quotationNumber: ShipArray[i]?.quotationNumber,
        deliveryTime: ShipArray[i]?.deliveryTime
          ? ShipArray[i]?.deliveryTime
          : null,
        originPostalCode: originDetail?.address.postalCode
          ? originDetail?.address.postalCode
          : '',
        originCity: originDetail?.address.city
          ? originDetail?.address.city
          : '',
        originStateOrProvinceCode: originDetail?.address.stateOrProvinceCode
          ? originDetail?.address.stateOrProvinceCode
          : '',
        originCountryCode: originDetail?.address.countryCode
          ? originDetail?.address.countryCode
          : '',

        originContactPersonName: originDetail?.contact?.personName,
        originContactCompanyName: originDetail?.contact?.companyName,

        originContactFaxNmb: originDetail?.contact.faxNumber,

        originContactPersonExtension: originDetail?.contact.phoneExtension,

        originContactPersonPhnNmb: originDetail?.contact.phoneNumber,
        originStreetLines: originDetail?.address.streetLines,

        origin: originDetail?.address.postalCode
          ? originDetail?.address.postalCode
          : '',
        originTerminaCity: originTerminalInfo?.address.city
          ? originDetail?.address.city
          : '',
        originTerminalStateOrProvinceCode: originTerminalInfo?.address
          .stateOrProvinceCode
          ? originTerminalInfo?.address.stateOrProvinceCode
          : '',
        originTerminalCountryCode: originTerminalInfo?.address.countryCode
          ? originTerminalInfo?.address.countryCode
          : '',

        originTerminalContactPersonName:
          originTerminalInfo?.contact?.personName,
        originTerminalContactCompanyName:
          originTerminalInfo?.contact?.companyName,

        originTerminalContactFaxNmb: originTerminalInfo?.contact.faxNumber,

        originTerminalContactPersonExtension:
          originTerminalInfo?.contact.phoneExtension,

        originTerminalContactPersonPhnNmb:
          originTerminalInfo?.contact.phoneNumber,
        originTerminalStreetLines: originTerminalInfo?.address.streetLines,

        destinationTerminaCity: destinationTerminalInfo?.address.city
          ? originDetail?.address.city
          : '',
        destinationTerminalStateOrProvinceCode: destinationTerminalInfo?.address
          .stateOrProvinceCode
          ? destinationTerminalInfo?.address.stateOrProvinceCode
          : '',
        destinationTerminalCountryCode: destinationTerminalInfo?.address
          .countryCode
          ? destinationTerminalInfo?.address.countryCode
          : '',

        destinationTerminalContactPersonName:
          destinationTerminalInfo?.contact?.personName,
        destinationTerminalContactCompanyName:
          destinationTerminalInfo?.contact?.companyName,

        destinationTerminalContactFaxNmb:
          destinationTerminalInfo?.contact.faxNumber,

        destinationTerminalContactPersonExtension:
          destinationTerminalInfo?.contact.phoneExtension,

        destinationTerminalContactPersonPhnNmb:
          destinationTerminalInfo?.contact.phoneNumber,
        destinationTerminalStreetLines:
          destinationTerminalInfo?.address.streetLines,

        destinationPostalCode: destinationDetail?.address.postalCode
          ? destinationDetail?.address.postalCode
          : '',
        destinationCity: destinationDetail?.address.city
          ? destinationDetail?.address.city
          : '',
        destinationStateOrProvinceCode: destinationDetail?.address
          .stateOrProvinceCode
          ? destinationDetail?.address.stateOrProvinceCode
          : '',
        destinationCountryCode: destinationDetail?.address.countryCode
          ? destinationDetail?.address.countryCode
          : '',
        destinationContactPersonName: destinationDetail?.contact?.personName,
        destinationContactCompanyName: destinationDetail?.contact?.companyName,
        destinationStreetLines: destinationDetail?.address.streetLines,

        destinationContactFaxNmb: destinationDetail?.contact.faxNumber,

        destinationContactPersonExtension:
          destinationDetail?.contact.phoneExtension,

        destinationContactPersonPhnNmb: destinationDetail?.contact.phoneNumber,

        totalSurcharge: ShipArray[i]?.totalSurcharge.amount,

        totalBillingWeight:
          ShipArray[i]?.totalBillingWeight.value == 0
            ? 0
            : ShipArray[i]?.totalBillingWeight.value +
                ' ' +
                ShipArray[i]?.totalBillingWeight.units !==
                null && ShipArray[i]?.totalBillingWeight.units,
        totalBaseCharge: ShipArray[i]?.totalBaseCharge.amount,
        totalCarrierCharge: ShipArray[i]?.totalCarrierCharge.amount,
        totalDistance: ShipArray[i]?.totalDistance.amount,
        totalDutiesAndTaxes: ShipArray[i]?.totalDutiesAndTaxes.amount,
        totalNetFreight: ShipArray[i]?.totalNetFreight.amount,
        totalNetChargeWithDutiesAndTaxes:
          ShipArray[i]?.totalNetChargeWithDutiesAndTaxes.amount,
        totalFreightDiscount: ShipArray[i]?.totalFreightDiscount.amount,
        netDiscount: ShipArray[i]?.netDiscount.amount,
        totalTaxes: ShipArray[i]?.totalTaxes.amount,
        surcharges: ShipArray[i]?.surcharges,
        Rate: ShipArray[i]?.totalNetCharge.amount,
        isGuaranteedDelviery: ShipArray[i]?.isGuaranteedDelviery,

        days: ShipArray[i]?.transitTime ? ShipArray[i]?.transitTime : ''
      });
    }
    setGetRatesArray(temp);

    // setGetRatesArray(temp);
  };
  const [value, setValue] = React.useState(0);

  const handleSortRatesArray = () => {
    if (value === 1) {
      const StandarArray = GetRatesArray.filter(
        items => items.isGuaranteedDelviery === false
      );
      SetGetRateStandarArray(StandarArray);
    }
    if (value === 2) {
      const GuaranteedArray = GetRatesArray.filter(
        items => items.isGuaranteedDelviery === true
      );
      SetGetRateGuaranteedArray(GuaranteedArray);
    }
    // if (value === 2) {
    //   const LowestPriceArray = GetRatesArray.sort((a, b) =>
    //     a.Rate > b.Rate ? 1 : -1
    //   );
    //   setGetRateLowestPriceArray(LowestPriceArray);
    // }
    if (value === 3) {
      const QuickestDeliveryArray = GetRatesArray.sort((c, d) =>
        c.days > d.days ? 1 : -1
      );
      setGetRateQuickDeliveryArray(QuickestDeliveryArray);
    }
  };

  useEffect(() => {
    handleSortRatesArray();
  }, [GetRatesArray, value]);

  const OriginLocation =
    obj?.shipFrom?.postalCode +
    ' ' +
    obj?.shipFrom?.city +
    ' ' +
    obj?.shipFrom?.stateOrProvinceCode +
    ' ' +
    obj?.shipFrom?.countryCode;
  const DestinationLocation =
    obj?.shipTo?.postalCode +
    ' ' +
    obj?.shipTo?.city +
    ' ' +
    obj?.shipTo?.stateOrProvinceCode +
    ' ' +
    obj?.shipTo?.countryCode;

  const OrderWeight = totalWeightLBS;
  const [originLoc, setOriginLoc] = useState(OriginLocation);
  const [destinationLoc, setDestinationLoc] = useState(DestinationLocation);
  const [requoteWeight, setRequoteWeight] = useState(OrderWeight);
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  const RateErrorTooltip = styled(({ className, ...props }) => (
    <Tooltip arrow {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#ce7a7a',
      color: 'white',
      maxWidth: 800,
      // width: 1900,
      // margin: '0 10 0 10 ',
      fontSize: theme.typography.pxToRem(12)
      // border: '1px solid #dadde9'
    },
    [`& .${tooltipClasses.arrow}`]: {
      // backgroundColor: '#f5f5f9',
      color: '#ce7a7a',
      maxWidth: 1100,
      // width: 1900,
      // margin: '0 10 0 10 ',
      fontSize: theme.typography.pxToRem(12)
      // border: '1px solid #dadde9'
    }
  }));

  useEffect(() => {
    handleAllCarrierRates(data);
  }, [data]);

  useEffect(() => {
    checkAllCarriersRates(callCount, finalCarrierApis.length);
  }, [callCount]);

  useEffect(() => {
    setCallCount(0);
    setFinalCarrierApis([]);
  }, [ReloadQuote]);

  const options = {
    // year: '2-digit',
    month: 'short',
    day: 'numeric'
  };
  // useEffect(() => {

  const uniqueIdCounterRef = useRef(1);
  let calledSuccess = 0;
  const handleSuccessResponse = (ApiRes, carrierType) => {
    setEstesApiLoading(false);
    setCallCount(prev => prev + 1);
    // if (calledSuccess === finalCarrierApis.length) {
    //   console.log('lopp completed');
    // } else {
    //   console.log('wait for lopp completed');
    // }
    ApiRes.data.shipmentDetails.forEach(shipmentDetail => {
      const uniqueId = uniqueIdCounterRef.current;
      uniqueIdCounterRef.current = uniqueIdCounterRef.current + 1;

      const formattedDate = new Date(shipmentDetail.deliveryTime)
        .toLocaleString('en-US', options)
        .toUpperCase();
      const yearLastTwoDigits = formattedDate.slice(-2);

      setSuccessRates(prevArray => [
        ...prevArray,
        {
          ...shipmentDetail,
          carrierType: carrierType,
          uniqueId: uniqueId,
          udeliveryTime: shipmentDetail.deliveryTime
            ? formattedDate.replace(yearLastTwoDigits, `${yearLastTwoDigits}`)
            : '',
          filterMode: !shipmentDetail.isGuaranteedDelviery
            ? 'standard'
            : shipmentDetail.isGuaranteedDelviery &&
                shipmentDetail.serviceType?.includes('5')
              ? 'g5'
              : shipmentDetail.isGuaranteedDelviery &&
                  shipmentDetail.serviceType?.includes('10')
                ? 'g10'
                : shipmentDetail.isGuaranteedDelviery &&
                    shipmentDetail.serviceType?.includes('12')
                  ? 'g12'
                  : 'other'
        }
      ]);
    });
  };

  const ErrMsgArray = [
    { title: 'CTQuoteRate', msg: '', logo: CTLogo },
    {
      title: 'FedEx',
      msg: '',
      logo: props?.state?.shipmentType === 'LTL' ? FedExLogo : FedExExpressLogo
    },
    { title: 'FedExParcelQuoteRate', msg: '', logo: FedExExpressLogo },
    { title: 'XPO', msg: '', logo: CNWYLogo },
    { title: 'Estes', msg: '', logo: EXLALogo },
    { title: 'SAIA', msg: '', logo: SAIALogo },
    { title: 'ABF', msg: '', logo: ABFLogo },
    { title: 'PittOhio', msg: '', logo: PITOHIO },
    { title: 'Sefl', msg: '', logo: SEFLlogo },
    { title: 'NewPenn', msg: '', logo: NEWPENLogo },
    { title: 'ODFL', msg: '', logo: ODFLlogo },
    {
      title: 'UPS',
      msg: '',
      logo: props?.state?.shipmentType === 'LTL' ? UPSLogo : UPSOldLogo
    },
    {
      title: 'YRC',
      msg: '',
      logo: YRCLogo
    },
    { title: 'Reddaway', msg: '', logo: ReddawayLogo },
    { title: 'Ward', msg: '', logo: WardLogo },
    { title: 'RL', msg: '', logo: RLLogo },
    { title: 'AduiePyle', msg: '', logo: PYLELogo },
    { title: 'AAACooper', msg: '', logo: AACTLogo },
    { title: 'Averitt', msg: '', logo: AVERITTLogo },
    { title: 'GLS', msg: '', logo: GLSLogo },
    { title: 'SMTL', msg: '', logo: SMTLLogo },
    { title: 'USRoadQuoteRate', msg: '', logo: USRoadQuoteRate },
    { title: 'DaytonQuoteRate', msg: '', logo: DaytonCarrierLogo },
    { title: 'DaylightQuoteRate', msg: '', logo: DayLightCarrierLogo }
  ];
  let tempErr = [];
  // let tempErr = [...errorMessageApi];
  const handleRejectRepsone = err => {
    setEstesApiLoading(false);
    setCallCount(prev => prev + 1);

    const ErrName = err?.response?.request?.responseURL?.split('/');
    const LastName = ErrName[ErrName?.length - 1];
    const errorMsgPair = {
      message: err?.response?.data
    };

    const ErrObj = {
      message:
        err?.response?.data.length > 2
          ? err?.response?.data
          : JSON.stringify(errorMsgPair, null, 2),
      URL: err?.response?.request?.responseURL,
      logo: ErrMsgArray.find(items =>
        LastName.includes(items.title) ? items.logo : null
      )
    };

    tempErr.push({
      message: err?.response?.data,
      URL: err?.response?.request?.responseURL
    });
    console.log(tempErr.length, 'tempErr', finalCarrierApis.length);
    if (tempErr.length === finalCarrierApis.length) {
      setChecked(true);
    }

    setErrorMessageApi(prevArray => [...prevArray, ErrObj]);

    setEstesApiLoading(false);
  };
  const fetchData = async (RequoteObj, DeepCloneRequoteObj) => {
    const GetAuthToken = () => {
      return sessionStorage.getItem('UserAuthToken');
    };

    const AgencyLoginHeader = axios.create({
      baseURL: base_url,
      responseType: 'json'
    });

    // Add an interceptor to update the Authorization header before each request
    AgencyLoginHeader.interceptors.request.use(
      async config => {
        const authToken = GetAuthToken();
        if (authToken) {
          config.headers.Authorization = `Bearer ${authToken}`;
        }
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    setData([]);
    setSuccessRates([]);
    setRateUniqueId(0);
    setGetRatesArray([]);
    setErrorMessageApi([]);
    if (RequoteObj !== undefined) {
      setOriginLoc(
        RequoteObj.shipFrom.city +
          ' ' +
          RequoteObj.shipFrom.stateOrProvinceCode +
          ' ' +
          RequoteObj.shipFrom.postalCode
      );
      setDestinationLoc(
        RequoteObj.shipTo.city +
          ' ' +
          RequoteObj.shipTo.stateOrProvinceCode +
          ' ' +
          RequoteObj.shipTo.postalCode
      );
      setRequoteWeight(RequoteObj?.commodityInfo[0]?.weight?.value);
    }
    finalCarrierApis.length === 0
      ? setEstesApiLoading(false)
      : setEstesApiLoading(true);

    let temp = RequoteObj !== undefined ? [] : [...data];
    for (let i = 0; i < finalCarrierApis.length; i++) {
      const carrierType = finalCarrierApis[i].includes('Parcel')
        ? 'Parcel'
        : 'LTL';
      const EndPoint = finalCarrierApis[i];
      RequoteObj !== undefined
        ? AgencyLoginHeader.post(EndPoint, deepCloneObj)
            .then(
              res =>
                res.status === 200 && handleSuccessResponse(res, carrierType)
            )
            .catch(err => handleRejectRepsone(err))
        : AgencyLoginHeader.post(EndPoint, deepCloneObj)
            .then(
              res =>
                res.status === 200 && handleSuccessResponse(res, carrierType)
            )
            .catch(err => handleRejectRepsone(err));
    }
  };

  const handleGetCarrierNames = data => {
    let tempApis = [];
    const CarrierArray = data.filter(
      items =>
        items.active &&
        (props?.state?.shipmentType === 'Parcel'
          ? items.cType === 'Parcel'
          : props?.state?.shipmentType === 'LTL'
            ? items.cType === 'LTL'
            : items.cType === 'LTL' || items.cType === 'Parcel')
    );
    if (CarrierArray.length === 0) {
      // setTimeout(() => {
      setNoActiveCarrier(true);
      setEstesApiLoading(false);
      // }, 2500);
    }
    for (let i = 0; i < CarrierArray.length; i++) {
      const CarrierName = CarrierArray[i]?.getRateEndPoint?.replace('/', '');
      const element = base_url + CarrierName;
      tempApis.push(element);
      // tempApis.push(element.includes('YRC') ? element : null);
    }
    setFinalCarrierApis(tempApis);
    // getPrice();
  };
  // useEffect(() => {
  // }, []);

  const CallCarrierRatesApi = () => {
    GetActiveCarriers(AgencyID, props.DataToShow.locationId)
      .then(res => res.status === 200 && handleGetCarrierNames(res.data.data))
      .catch(err => console.log('Error here...', err));
  };

  const handleFilterValueChange = (event, newValue) => {
    setFilterValue(newValue);
  };
  const handleSortValueChange = (event, newValue) => {
    setSortValue(newValue);
  };

  const handleSortToggle = () => {
    setSortOrder(prevOrder => (prevOrder === 'ASC' ? 'DESC' : 'ASC'));
  };
  const applyFilter = item => {
    switch (filterKey) {
      case '*':
        return true;
      case 'g5':
        return item.filterMode === 'g5';
      case 'g10':
        return item.filterMode === 'g10';
      case 'g12':
        return item.filterMode === 'g12';
      case 'standard':
        return item.filterMode === 'standard';
      case 'guaranteed':
        return item.isGuaranteedDelviery;
      default:
        return false;
    }
  };

  const applySort = (rowA, rowB) => {
    switch (sortKey) {
      case 'price':
        return sortOrder === 'ASC'
          ? rowA.totalNetCharge.amount - rowB.totalNetCharge.amount
          : rowB.totalNetCharge.amount - rowA.totalNetCharge.amount;
      case 'days':
        const daysA = isNaN(parseInt(rowA.transitTime))
          ? 9999
          : parseInt(rowA.transitTime);
        const daysB = isNaN(parseInt(rowB.transitTime))
          ? 9999
          : parseInt(rowB.transitTime);
        return sortOrder === 'ASC' ? daysA - daysB : daysB - daysA;
      case 'name':
        return sortOrder === 'ASC'
          ? rowA.carrierInfo.name.localeCompare(rowB.carrierInfo.name)
          : rowB.carrierInfo.name.localeCompare(rowA.carrierInfo.name);
      default:
        return 0; // Default case: no sorting
    }
  };

  const applySubChargesSort = (rowA, rowB) => {
    return rowA.order - rowB.order;
  };
  function findLowestPriceAndQuickestDelivery(array) {
    let lowestPrice = null;
    let quickestDelivery = null;

    array.forEach(item => {
      if (
        item.totalNetCharge &&
        item.totalNetCharge.amount !== null &&
        (lowestPrice === null ||
          item.totalNetCharge.amount < lowestPrice.totalNetCharge.amount)
      ) {
        lowestPrice = item;
      }

      if (
        item.transitTime > 0 &&
        !isNaN(item.transitTime) &&
        (quickestDelivery === null ||
          parseInt(item.transitTime, 10) <
            parseInt(quickestDelivery.transitTime, 10))
      ) {
        quickestDelivery = item;
      }
    });

    return { lowestPrice, quickestDelivery };
  }

  useEffect(() => {
    const result = findLowestPriceAndQuickestDelivery(successRates);
    setLowestCostCarrier(result.lowestPrice);
    setQuickestCarrier(result.quickestDelivery);
  }, [successRates]);

  const handleViewRate = (event, rate) => {
    event.stopPropagation();
    setCurrentRate(rate);
    setDetailModal(true);
  };

  const handleViewRate1 = (event, rate) => {
    event.stopPropagation();
    setCurrentRate(rate);
    setTerminalModal(true);
  };

  const handleKanbanCardClicked = (id, rate) => {
    // setCurrentKanabn(id);
    // setRateToBook(rate);
    const surchargesArr = lowestCostCarrier.surcharges.find(
      item => item.description === 'Surcharge'
    );

    handleListItemClick(
      {
        carrierName: rate.carrierInfo.name,
        carrierID: rate.carrierInfo.id,
        quotationNumber: rate.quotationNumber,
        totalNetCharge: rate.totalNetCharge.amount,
        serviceType: rate.serviceType,
        deliveryTime: rate.deliveryTime,
        transitTime: rate.transitTime,
        originTerminal: rate.originTerminal.contactAndAddress,
        destinationTerminal: rate.destinationTerminal.contactAndAddress,
        carrierType: rate.carrierType,
        surcharges: rate.surcharges,
        isThirdPartyRate: rate.isThirdPartyRate,
        leastCostCarrier: lowestCostCarrier?.carrierInfo?.id
          ? lowestCostCarrier?.carrierInfo?.id
          : 0,
        leastCost: lowestCostCarrier?.totalNetChargeWithoutAgencySurcharge
          ?.amount
          ? lowestCostCarrier?.totalNetChargeWithoutAgencySurcharge?.amount
          : 0,
        leastCostAgencySurcharge: surchargesArr?.amount?.amount
          ? surchargesArr?.amount?.amount
          : 0,
        // leastTransitCarrier: quickestCarrier?.carrierInfo?.id
        //   ? quickestCarrier?.carrierInfo?.id
        //   : 0,
        leastTransitDays:
          lowestCostCarrier?.transitTime > 0
            ? lowestCostCarrier?.transitTime
            : 0
      },
      id
    );
  };

  const formatePrice = price => {
    return price?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    backgroundColor: 'white',
    maxHeight: '90vh',
    overflowY: 'auto'
  };

  return (
    <div>
      <ToastContainer
        style={
          // isMobile
          //   ? { width: '100%', display: 'flex', justifyContent: 'center' }
          // :
          { width: 'auto' }
        }
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <React.Fragment>
        <Modal
          open={terminalModal}
          onClose={() => setTerminalModal(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
          scroll='paper'
        >
          <Box
            className=' py-3 d-flex flex-column detail-bottom-drawer'
            sx={{
              ...style,
              width: { xs: '100%', sm: '50%', lg: '50%', xl: '50%' }
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }}>
              <IconButton
                onClick={() => setTerminalModal(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme => theme.palette.grey[500]
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <div
              className=' py-3 mt-4 d-flex flex-column '
              style={{ width: '97%' }}
            >
              <Row
                className='px-3 d-flex flex-row'
                style={{ marginTop: '-30', marginBottom: -10 }}
              >
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className=''>
                    <img
                      alt={'st'}
                      src={`${base_logo_url}carrier_logos/${currentRate?.carrierInfo?.logo}`}
                      width={90}
                    />
                  </div>
                </Col>
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className='d-block'>
                    <Typography
                      variant='h4'
                      className='fw-bold'
                      style={{ textAlign: 'center' }}
                    >
                      <span className='dayss'>
                        {isNaN(parseInt(currentRate.transitTime))
                          ? 'N/A'
                          : currentRate.transitTime === '0'
                            ? 'N/A'
                            : parseInt(currentRate.transitTime)}
                      </span>
                    </Typography>
                    <Typography
                      variant='body1'
                      className='text-black'
                      style={{ fontSize: '14px', textAlign: 'center' }}
                    >
                      Service Day(s)
                    </Typography>
                  </div>
                </Col>
              </Row>

              <Row className='px-3 d-flex flex-row ' style={{}}>
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant='h6'
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Origin Terminal Info
                    </Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Address
                    </Typography>
                    <Typography
                      // onClick={() => getRandomAddress()}
                      variant='h5'
                      className='info-label-value'
                    >{`${
                      currentRate?.originTerminal?.contactAndAddress?.address
                        ?.streetLines
                        ? currentRate?.originTerminal?.contactAndAddress
                            ?.address?.streetLines
                        : ' '
                    }`}</Typography>
                    <Typography
                      // onClick={() => handleOpenMap(currentRate?.originTerminal)}
                      variant='h5'
                      className='info-label-value'
                    >{`${
                      currentRate?.originTerminal?.contactAndAddress?.address
                        ?.city
                        ? currentRate?.originTerminal?.contactAndAddress
                            ?.address?.city + ','
                        : ' '
                    } ${
                      currentRate?.originTerminal?.contactAndAddress?.address
                        ?.stateOrProvinceCode
                        ? currentRate?.originTerminal?.contactAndAddress
                            ?.address?.stateOrProvinceCode + ','
                        : ''
                    } ${
                      currentRate?.originTerminal?.contactAndAddress?.address
                        ?.postalCode
                        ? currentRate?.originTerminal?.contactAndAddress
                            ?.address?.postalCode
                        : ''
                    }`}</Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Phone
                    </Typography>
                    <Typography variant='h5' className='info-label-value'>
                      <PhoneAndroidOutlinedIcon
                        style={{
                          height: 18,
                          width: 18
                        }}
                      />
                      {currentRate?.originTerminal?.contactAndAddress?.contact
                        ?.phoneNumber ? (
                        <a
                          className='call-phone-number'
                          href={`tel:${currentRate?.originTerminal?.contactAndAddress?.contact?.phoneNumber}`}
                        >
                          {currentRate?.originTerminal?.contactAndAddress?.contact?.phoneNumber?.replace(
                            /\D/g,
                            ''
                          ).length < 11
                            ? currentRate?.originTerminal?.contactAndAddress?.contact?.phoneNumber
                                ?.replace(/\D/g, '')
                                ?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            : currentRate?.originTerminal?.contactAndAddress
                                ?.contact?.phoneNumber}
                        </a>
                      ) : (
                        ' '
                      )}
                    </Typography>
                  </div>
                </Col>
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant='h6'
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Destination Terminal Info
                    </Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Address
                    </Typography>
                    <Typography variant='h5' className='info-label-value'>{`${
                      currentRate?.destinationTerminal?.contactAndAddress
                        ?.address?.streetLines
                        ? currentRate?.destinationTerminal?.contactAndAddress
                            ?.address?.streetLines
                        : ' '
                    }`}</Typography>
                    <Typography variant='h5' className='info-label-value'>{`${
                      currentRate?.destinationTerminal?.contactAndAddress
                        ?.address?.city
                        ? currentRate?.destinationTerminal?.contactAndAddress
                            ?.address?.city + ','
                        : ' '
                    } ${
                      currentRate?.destinationTerminal?.contactAndAddress
                        ?.address?.stateOrProvinceCode
                        ? currentRate?.destinationTerminal?.contactAndAddress
                            ?.address?.stateOrProvinceCode + ','
                        : ''
                    } ${
                      currentRate?.destinationTerminal?.contactAndAddress
                        ?.address?.postalCode
                        ? currentRate?.destinationTerminal?.contactAndAddress
                            ?.address?.postalCode
                        : ''
                    }`}</Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Phone
                    </Typography>
                    <Typography variant='h5' className='info-label-value'>
                      <PhoneAndroidOutlinedIcon
                        style={{
                          height: 18,
                          width: 18
                        }}
                      />
                      {currentRate?.destinationTerminal?.contactAndAddress
                        ?.contact?.phoneNumber ? (
                        <a
                          className='call-phone-number'
                          href={`tel:${currentRate?.destinationTerminal?.contactAndAddress?.contact?.phoneNumber}`}
                        >
                          {currentRate?.destinationTerminal?.contactAndAddress?.contact?.phoneNumber?.replace(
                            /\D/g,
                            ''
                          ).length < 11
                            ? currentRate?.destinationTerminal?.contactAndAddress?.contact?.phoneNumber
                                ?.replace(/\D/g, '')
                                ?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            : currentRate?.destinationTerminal
                                ?.contactAndAddress?.contact.phoneNumber}
                        </a>
                      ) : (
                        ' '
                      )}
                    </Typography>
                  </div>
                </Col>
              </Row>
            </div>
          </Box>
        </Modal>

        <Modal
          open={detailModal}
          onClose={() => setDetailModal(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box
            sx={{
              ...style,
              width: { xs: '100%', sm: '100%', lg: '40%', xl: '40%' },
              maxHeight: '90vh',
              overflowY: 'auto',
              p: 3,
              position: 'relative'
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => setDetailModal(false)}
              size='small'
              sx={{ position: 'absolute', top: 12, right: 12 }}
            >
              <CloseIcon fontSize='small' />
            </IconButton>

            {/* Carrier Logo */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <img
                alt='carrier-logo'
                src={`${base_logo_url}carrier_logos/${currentRate?.carrierInfo?.logo}`}
                height={60}
                style={{ objectFit: 'contain' }}
              />
            </Box>

            {/* ── Shipment Details ── */}
            <Typography
              variant='caption'
              sx={{
                color: '#1565c0',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                display: 'block',
                mb: 1
              }}
            >
              Shipment Details
            </Typography>

            <Box sx={{ bgcolor: '#fafafa', borderRadius: 1, p: 1.5, mb: 2.5 }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '0 24px'
                }}
              >
                {/* Left column */}
                <Box>
                  {[
                    {
                      label: 'Carrier Name',
                      value: currentRate?.carrierInfo?.name || 'N/A'
                    },
                    {
                      label: 'Quote Reference',
                      value: currentRate?.quotationNumber || 'N/A'
                    },
                    {
                      label: 'Service Type',
                      value: currentRate?.serviceType || 'Standard (ST)'
                    },
                    {
                      label: 'Service Days',
                      value:
                        currentRate?.transitTime === '0' ||
                        !currentRate?.transitTime
                          ? 'N/A'
                          : `${currentRate.transitTime} Business Day(s)`
                    }
                  ].map(({ label, value }) => (
                    <Box
                      key={label}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: '5px',
                        px: '6px',
                        borderBottom: '0.5px solid',
                        borderColor: 'divider',
                        borderRadius: '4px',
                        cursor: 'default',
                        transition: 'background-color 0.15s ease',
                        '&:hover': { bgcolor: '#f5f5f5' }
                      }}
                    >
                      <Typography variant='body2' fontWeight={600}>
                        {label}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{ textAlign: 'right', ml: 1 }}
                      >
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                {/* Right column */}
                <Box>
                  {[
                    {
                      label: 'Origin',
                      value:
                        quoteType === 'Quick Quote'
                          ? `${SelectedRowData?.shipFrom?.city || ''} ${SelectedRowData?.shipFrom?.stateOrProvinceCode || ''} ${SelectedRowData?.shipFrom?.postalCode || ''}`.trim() ||
                            'N/A'
                          : `${SelectedRowData?.originCity || ''} ${SelectedRowData?.originState || ''} ${SelectedRowData?.originZipCode || ''} ${SelectedRowData?.originCountry || ''}`.trim() ||
                            'N/A'
                    },
                    {
                      label: 'Destination',
                      value:
                        quoteType === 'Quick Quote'
                          ? `${SelectedRowData?.shipTo?.city || ''} ${SelectedRowData?.shipTo?.stateOrProvinceCode || ''} ${SelectedRowData?.shipTo?.postalCode || ''}`.trim() ||
                            'N/A'
                          : `${SelectedRowData?.destinationCity || ''} ${SelectedRowData?.destinationState || ''} ${SelectedRowData?.destinationZipCode || ''} ${SelectedRowData?.destinationCountry || ''}`.trim() ||
                            'N/A'
                    },
                    {
                      label: 'Weight',
                      value:
                        quoteType === 'Quick Quote'
                          ? `${OrderWeight || 'N/A'} lbs`
                          : `${SelectedRowData?.details?.[0]?.netWeight || 'N/A'} lbs`
                    },
                    ...(currentRate?.carrierType === 'LTL'
                      ? [
                          {
                            label: 'Freight Class',
                            value:
                              quoteType === 'Quick Quote'
                                ? SelectedRowData?.commodityInfo?.[0]
                                    ?.freightClass || 'N/A'
                                : SelectedRowData?.details?.[0]?.freightClass ||
                                  'N/A'
                          }
                        ]
                      : [])
                  ].map(({ label, value }) => (
                    <Box
                      key={label}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: '5px',
                        px: '6px',
                        borderBottom: '0.5px solid',
                        borderColor: 'divider',
                        borderRadius: '4px',
                        cursor: 'default',
                        transition: 'background-color 0.15s ease',
                        '&:hover': { bgcolor: '#f5f5f5' }
                      }}
                    >
                      <Typography variant='body2' fontWeight={600}>
                        {label}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{ textAlign: 'right', ml: 1 }}
                      >
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>

            {/* ── Base Charges Breakdown ── */}
            <Typography
              variant='caption'
              sx={{
                color: '#1565c0',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                display: 'block',
                mb: 1
              }}
            >
              Base Charges Breakdown
            </Typography>

            <Box
              sx={{
                border: '0.5px solid',
                borderColor: 'divider',
                borderRadius: 1,
                overflow: 'hidden',
                mb: 2.5
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  px: 1.75,
                  py: '7px',
                  bgcolor: '#f5f5f5',
                  borderBottom: '0.5px solid',
                  borderColor: 'divider'
                }}
              >
                <Typography
                  variant='caption'
                  fontWeight={600}
                  color='text.secondary'
                >
                  Item
                </Typography>
                <Typography
                  variant='caption'
                  fontWeight={600}
                  color='text.secondary'
                >
                  Amount
                </Typography>
              </Box>

              {/* Rows */}
              {currentRate?.surcharges
                ?.sort(applySubChargesSort)
                .filter(s =>
                  baseRateDescrptions?.includes(s.description.trim())
                )
                .map((surcharge, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      px: 1.75,
                      py: '7px',
                      borderBottom: '0.5px solid',
                      borderColor: 'divider',
                      cursor: 'default',
                      transition: 'background-color 0.15s ease',
                      '&:hover': { bgcolor: '#fafafa' }
                    }}
                  >
                    <Typography variant='body2' fontWeight={600}>
                      {surcharge.description}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      {surcharge?.description?.includes('%')
                        ? `${surcharge.amount?.amount.toFixed(2)}%`
                        : formatePrice(surcharge.amount?.amount)}
                    </Typography>
                  </Box>
                ))}

              {/* Total row */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  px: 1.75,
                  py: '7px',
                  bgcolor: '#f5f5f5'
                }}
              >
                <Typography variant='body2' fontWeight={700}>
                  Total Base Charges
                </Typography>
                <Typography variant='body2' fontWeight={700}>
                  {formatePrice(
                    currentRate.surcharges
                      ?.sort(applySubChargesSort)
                      .filter(s =>
                        [
                          'Line Haul',
                          'Fuel Surcharge Value',
                          'Surcharge'
                        ].includes(s.description)
                      )
                      .reduce((total, s) => total + (s.amount?.amount || 0), 0)
                  )}
                </Typography>
              </Box>
            </Box>

            {/* ── Accessorial Charges ── */}
            {currentRate?.surcharges?.some(
              s => !baseRateDescrptions?.includes(s.description.trim())
            ) && (
              <>
                <Typography
                  variant='caption'
                  sx={{
                    color: '#1565c0',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    display: 'block',
                    mb: 1
                  }}
                >
                  Accessorial Charges
                </Typography>

                <Box
                  sx={{
                    border: '0.5px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    overflow: 'hidden',
                    mb: 2.5
                  }}
                >
                  {/* Header */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      px: 1.75,
                      py: '7px',
                      bgcolor: '#f5f5f5',
                      borderBottom: '0.5px solid',
                      borderColor: 'divider'
                    }}
                  >
                    <Typography
                      variant='caption'
                      fontWeight={600}
                      color='text.secondary'
                    >
                      Item
                    </Typography>
                    <Typography
                      variant='caption'
                      fontWeight={600}
                      color='text.secondary'
                    >
                      Amount
                    </Typography>
                  </Box>

                  {/* Rows */}
                  {currentRate?.surcharges
                    ?.sort(applySubChargesSort)
                    .filter(
                      s => !baseRateDescrptions?.includes(s.description.trim())
                    )
                    .map((surcharge, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          px: 1.75,
                          py: '7px',
                          borderBottom: '0.5px solid',
                          borderColor: 'divider',
                          cursor: 'default',
                          transition: 'background-color 0.15s ease',
                          '&:hover': { bgcolor: '#fafafa' }
                        }}
                      >
                        <Typography variant='body2' fontWeight={600}>
                          {surcharge.description}
                        </Typography>
                        <Typography variant='body2' color='text.secondary'>
                          {surcharge?.description?.includes('%')
                            ? `${surcharge.amount?.amount?.toFixed(2)}%`
                            : formatePrice(surcharge.amount?.amount)}
                        </Typography>
                      </Box>
                    ))}

                  {/* Total row */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      px: 1.75,
                      py: '7px',
                      bgcolor: '#f5f5f5'
                    }}
                  >
                    <Typography variant='body2' fontWeight={700}>
                      Total Accessorial Charges
                    </Typography>
                    <Typography variant='body2' fontWeight={700}>
                      {formatePrice(
                        currentRate?.surcharges
                          ?.sort(applySubChargesSort)
                          .filter(
                            s =>
                              !baseRateDescrptions?.includes(
                                s?.description?.trim()
                              )
                          )
                          .reduce(
                            (total, s) => total + (s.amount?.amount || 0),
                            0
                          )
                      )}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}

            {/* ── Total Net Charge ── */}
            {currentRate?.surcharges?.some(
              s => !baseRateDescrptions?.includes(s.description.trim())
            ) && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: 1.5,
                  bgcolor: '#e3f2fd',
                  borderRadius: 1,
                  px: 2,
                  py: 1.25,
                  mb: 2.5
                }}
              >
                <Typography
                  variant='body2'
                  fontWeight={600}
                  sx={{ color: '#1565c0' }}
                >
                  Total Net Charge
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight={700}
                  sx={{ color: '#1565c0' }}
                >
                  {formatePrice(currentRate?.totalNetCharge?.amount)}
                </Typography>
              </Box>
            )}

            {/* ── Terminal Info ── */}
            <Typography
              variant='caption'
              sx={{
                color: '#1565c0',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                display: 'block',
                mb: 1
              }}
            >
              Terminal Info
            </Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 1.25
              }}
            >
              {[
                { label: 'Origin', terminal: currentRate?.originTerminal },
                {
                  label: 'Destination',
                  terminal: currentRate?.destinationTerminal
                }
              ].map(({ label, terminal }) => {
                const contact = terminal?.contactAndAddress;
                const addr = contact?.address;
                const phone = contact?.contact?.phoneNumber;

                const formattedPhone = phone
                  ? phone.replace(/\D/g, '').length < 11
                    ? phone
                        .replace(/\D/g, '')
                        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                    : phone
                  : null;

                const fullAddress =
                  `${addr?.streetLines || ''} ${addr?.city || ''} ${addr?.stateOrProvinceCode || ''} ${addr?.postalCode || ''}`.trim() ||
                  'N/A';

                return (
                  <Box
                    key={label}
                    sx={{ bgcolor: '#fafafa', borderRadius: 1, p: 1.5 }}
                  >
                    <Typography
                      variant='caption'
                      sx={{
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.04em',
                        color: '#1565c0',
                        display: 'block',
                        mb: 1
                      }}
                    >
                      {label}
                    </Typography>

                    {[
                      { sublabel: 'Address', value: fullAddress },
                      {
                        sublabel: 'Phone',
                        value: formattedPhone,
                        isPhone: true,
                        rawPhone: phone
                      }
                    ].map(({ sublabel, value, isPhone, rawPhone }) => (
                      <Box
                        key={sublabel}
                        sx={{
                          py: '5px',
                          px: '4px',
                          borderBottom: '0.5px solid',
                          borderColor: 'divider',
                          borderRadius: '4px',
                          cursor: 'default',
                          transition: 'background-color 0.15s ease',
                          '&:hover': { bgcolor: '#f5f5f5' },
                          '&:last-of-type': { borderBottom: 'none' }
                        }}
                      >
                        <Typography
                          variant='caption'
                          fontWeight={600}
                          color='text.primary'
                          sx={{ display: 'block' }}
                        >
                          {sublabel}
                        </Typography>
                        {isPhone && value ? (
                          <Typography variant='body2' color='text.secondary'>
                            <a
                              href={`tel:${rawPhone?.replace(/\D/g, '')}`}
                              style={{
                                color: '#1565c0',
                                textDecoration: 'none'
                              }}
                            >
                              {value}
                            </a>
                          </Typography>
                        ) : (
                          <Typography variant='body2' color='text.secondary'>
                            {value || 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    ))}
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Modal>
      </React.Fragment>

      <Box sx={{ mt: { xs: 0.2, md: -4, lg: -4, xl: -4 } }}>
        {isMobile ? (
          <Accordion sx={{ m: 0.5, width: '90%' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1-content'
              id='panel1-header'
            >
              <Typography component='span'>Rating Filters</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid sx={{ mt: -3 }} container>
                <Grid
                  item
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: {
                      xs: 'column',
                      sm: 'row',
                      md: 'row',
                      lg: 'row',
                      xl: 'row'
                    }
                    // mx: 2
                  }}
                  // className='d-flex flex-row mx-2'
                  // style={{
                  //   justifyContent: 'space-between'
                  //   // width: '115%'
                  // }}
                >
                  <Box className='d-flex' sx={{ alignItems: 'center' }}>
                    {/* <Typography variant="h6" className="fw-bold text-black me-2" style={{ cursor: 'pointer', fontSize: '13px' }} ><FilterAltIcon style={{ fontSize: '16px' }} /> Filter</Typography> */}
                    <Tabs
                      onChange={handleFilterValueChange}
                      value={filterValue}
                      aria-label='Tabs where selection follows focus'
                      selectionFollowsFocus
                    >
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        onClick={() => setFilterKey('*')}
                        label='All'
                      />
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        onClick={() => setFilterKey('standard')}
                        label='Standard'
                      />
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        onClick={() => setFilterKey('guaranteed')}
                        label='Guaranteed'
                      />
                      {/* <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g10')} label="10:00 - 10:30 AM" />
            <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g12')} label="12:00 PM" />
            <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g5')} label="05:00 PM" /> */}
                    </Tabs>
                  </Box>
                  <Box className='d-flex' sx={{ alignItems: 'center', mt: -1 }}>
                    <Typography
                      variant='h6'
                      className='fw-bold text-black me-2'
                      style={{ cursor: 'pointer', fontSize: '13px' }}
                      onClick={handleSortToggle}
                    >
                      {sortOrder === 'ASC' ? (
                        <SortIcon
                          style={{
                            transform: 'rotateX(180deg)',
                            fontSize: '16px'
                          }}
                        />
                      ) : (
                        <SortIcon style={{ fontSize: '16px' }} />
                      )}{' '}
                      Sort
                    </Typography>
                    <Tabs
                      onChange={handleSortValueChange}
                      value={sortValue}
                      aria-label='Tabs where selection follows focus'
                      selectionFollowsFocus
                    >
                      {/* icon={sortOrder === 'ASC' ? <SortIcon style={{ transform: 'rotateX(180deg)' }} /> : <SortIcon />} */}
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        iconPosition='start'
                        label='Price'
                        onClick={() => setSortKey('price')}
                      />
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        iconPosition='start'
                        label='Days'
                        onClick={() => setSortKey('days')}
                      />
                      <Tab
                        sx={{
                          fontSize: '13px',
                          minWidth: 'auto',
                          textTransform: 'none'
                        }}
                        className='px-2 fw-bold'
                        iconPosition='start'
                        label={
                          sortOrder === 'ASC' ? 'Carrier A-Z' : 'Carrier Z-A'
                        }
                        onClick={() => setSortKey('name')}
                      />
                    </Tabs>
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid
                  // className='d-flex flex-row'
                  // style={{
                  //   justifyContent: 'space-between',
                  //   marginTop: '-6px',
                  //   marginBottom: '-6px'
                  //   // width: '115%'
                  // }}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: {
                      xs: 'column',
                      sm: 'column',
                      md: 'row',
                      lg: 'row',
                      xl: 'row'
                    },
                    // mx: 2,
                    justifyContent: 'space-between'
                    // marginTop: '-6px',
                    // marginBottom: '-6px'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      flexDirection: {
                        xs: 'column',
                        sm: 'row',
                        md: 'row',
                        lg: 'row',
                        xl: 'row'
                      },
                      alignItems: {
                        xs: 'column',
                        sm: 'center',
                        md: 'center',
                        lg: 'center',
                        xl: 'center'
                      }
                      // mt: 1
                    }}
                  >
                    <Box>
                      <Typography
                        variant='body2'
                        sx={{
                          display: 'flex',
                          justifyContent: {
                            xs: 'space-between'
                          }
                        }}
                      >
                        <b>Origin:</b> {originLoc}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: {
                            xs: 'space-between'
                          }
                        }}
                        variant='body2'
                      >
                        <b>Destination:</b> {destinationLoc}
                      </Typography>
                    </Box>
                    {props?.state.shipmentType !== 'Parcel' && (
                      <Box>
                        <Typography
                          sx={{
                            display: 'flex',
                            justifyContent: {
                              xs: 'space-between'
                            }
                          }}
                          variant='body2'
                        >
                          <b>Class:</b>{' '}
                          {quoteType === 'Quick Quote'
                            ? SelectedRowData?.commodityInfo?.[0]?.freightClass
                            : SelectedRowData?.details[0]?.freightClass}
                        </Typography>
                      </Box>
                    )}
                    <Box>
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: {
                            xs: 'space-between'
                          }
                        }}
                        variant='body2'
                      >
                        <b>Weight:</b> {requoteWeight}
                      </Typography>
                    </Box>
                  </Box>
                  <Chip
                    size='small'
                    sx={{ mt: 1 }}
                    // variant='outlined'
                    label={
                      <FormControlLabel
                        onChange={e => console.log(e, 'swithchange')}
                        control={
                          <Switch
                            checked={checked}
                            onChange={handleShowHideErrosChnage}
                            // color='error'
                            size='small'
                          />
                        }
                        label={
                          <Typography variant='body2' sx={{ fontSize: '13px' }}>
                            {checked
                              ? 'Hide invalid carriers'
                              : 'Show invalid carriers'}
                          </Typography>
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
            <Grid container>
              <Grid
                item
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: {
                    xs: 'column',
                    sm: 'row',
                    md: 'row',
                    lg: 'row',
                    xl: 'row'
                  },
                  mx: 2
                }}
                // className='d-flex flex-row mx-2'
                // style={{
                //   justifyContent: 'space-between'
                //   // width: '115%'
                // }}
              >
                <Box className='d-flex mb-2' sx={{ alignItems: 'center' }}>
                  {/* <Typography variant="h6" className="fw-bold text-black me-2" style={{ cursor: 'pointer', fontSize: '13px' }} ><FilterAltIcon style={{ fontSize: '16px' }} /> Filter</Typography> */}
                  <Tabs
                    onChange={handleFilterValueChange}
                    value={filterValue}
                    aria-label='Tabs where selection follows focus'
                    selectionFollowsFocus
                  >
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      onClick={() => setFilterKey('*')}
                      label='All'
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      onClick={() => setFilterKey('standard')}
                      label='Standard'
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      onClick={() => setFilterKey('guaranteed')}
                      label='Guaranteed'
                    />
                    {/* <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g10')} label="10:00 - 10:30 AM" />
            <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g12')} label="12:00 PM" />
            <Tab sx={{ fontSize: '13px', minWidth: 'auto', textTransform: 'none' }} className="px-2 fw-bold" onClick={() => setFilterKey('g5')} label="05:00 PM" /> */}
                  </Tabs>
                </Box>
                <Fade in={callCount !== finalCarrierApis.length} timeout={500}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      maxHeight: '30px',
                      backgroundColor: '#f9f9f9',
                      borderRadius: 10,
                      px: 2.5,
                      mt: 2,
                      width: 'fit-content',
                      boxShadow: 1,
                      opacity: 0.5
                    }}
                  >
                    <CircularProgress size={12} thickness={4} />
                    <Typography variant='caption' sx={{ fontSize: 12 }}>
                      Loading carrier rates... A few carriers are responding
                      slower than expected.
                    </Typography>
                  </Box>
                </Fade>

                <Box className='d-flex' sx={{ alignItems: 'center' }}>
                  <Typography
                    variant='h6'
                    className='fw-bold text-black me-2'
                    style={{ cursor: 'pointer', fontSize: '13px' }}
                    onClick={handleSortToggle}
                  >
                    {sortOrder === 'ASC' ? (
                      <SortIcon
                        style={{
                          transform: 'rotateX(180deg)',
                          fontSize: '16px'
                        }}
                      />
                    ) : (
                      <SortIcon style={{ fontSize: '16px' }} />
                    )}{' '}
                    Sort
                  </Typography>
                  <Tabs
                    onChange={handleSortValueChange}
                    value={sortValue}
                    aria-label='Tabs where selection follows focus'
                    selectionFollowsFocus
                  >
                    {/* icon={sortOrder === 'ASC' ? <SortIcon style={{ transform: 'rotateX(180deg)' }} /> : <SortIcon />} */}
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label='Price'
                      onClick={() => setSortKey('price')}
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label='Days'
                      onClick={() => setSortKey('days')}
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label={
                        sortOrder === 'ASC' ? 'Carrier A-Z' : 'Carrier Z-A'
                      }
                      onClick={() => setSortKey('name')}
                    />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                // className='d-flex flex-row'
                // style={{
                //   justifyContent: 'space-between',
                //   marginTop: '-6px',
                //   marginBottom: '-6px'
                //   // width: '115%'
                // }}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: {
                    xs: 'column',
                    sm: 'column',
                    md: 'row',
                    lg: 'row',
                    xl: 'row'
                  },
                  mx: 2,
                  justifyContent: 'space-between',
                  marginTop: '-6px',
                  marginBottom: '-6px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    flexDirection: {
                      xs: 'column',
                      sm: 'row',
                      md: 'row',
                      lg: 'row',
                      xl: 'row'
                    },
                    alignItems: {
                      xs: 'column',
                      sm: 'center',
                      md: 'center',
                      lg: 'center',
                      xl: 'center'
                    },
                    mt: 1
                  }}
                >
                  <Box>
                    <Typography
                      variant='body2'
                      sx={{
                        display: 'flex',
                        justifyContent: {
                          xs: 'space-between'
                        }
                      }}
                    >
                      <b>Origin:</b> {originLoc}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        display: 'flex',
                        justifyContent: {
                          xs: 'space-between'
                        }
                      }}
                      variant='body2'
                    >
                      <b>Destination:</b> {destinationLoc}
                    </Typography>
                  </Box>
                  {props?.state.shipmentType !== 'Parcel' && (
                    <Box>
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: {
                            xs: 'space-between'
                          }
                        }}
                        variant='body2'
                      >
                        <b>Class:</b>{' '}
                        {quoteType === 'Quick Quote'
                          ? SelectedRowData?.commodityInfo?.[0]?.freightClass
                          : SelectedRowData?.details[0]?.freightClass}
                      </Typography>
                    </Box>
                  )}
                  <Box>
                    <Typography
                      sx={{
                        display: 'flex',
                        justifyContent: {
                          xs: 'space-between'
                        }
                      }}
                      variant='body2'
                    >
                      <b>Weight:</b> {requoteWeight}
                    </Typography>
                  </Box>
                </Box>
                <Chip
                  sx={{ mt: 1 }}
                  // variant='outlined'
                  label={
                    <FormControlLabel
                      onChange={e => console.log(e, 'swithchange')}
                      control={
                        <Switch
                          checked={checked}
                          onChange={handleShowHideErrosChnage}
                          // color='error'
                          size='small'
                        />
                      }
                      label={
                        <Typography variant='body2' sx={{ fontSize: '13px' }}>
                          {checked
                            ? 'Hide invalid carriers'
                            : 'Show invalid carriers'}
                        </Typography>
                      }
                    />
                  }
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid
          container
          sx={{
            p: 0.5,
            height: {
              xs: '87%',
              sm: '87%',
              md: '68%',
              lg: '68%',
              xl: '68%'
            },
            overflowY: {
              xs: 'unset',
              sm: 'unset',
              md: 'auto',
              lg: 'auto',
              xl: 'auto'
            }
          }}
          // className='rates-data-container'
        >
          <Grid
            sx={{
              // mb: {
              //   xs: 7,
              //   sm: 0,
              //   md: 0,
              //   lg: 0,
              //   xl: 0
              // },
              height: {
                xs: '70%',
                sm: '70%',
                md: '97vh',
                lg: '97vh',
                xl: '97vh'
              }
            }}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            {EstesApiLoading ? (
              LoadingArray.map(items => (
                <div className='Error_Carrier_div_LTL'>
                  <Row
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={
                        EstesApiLoading
                          ? {
                              width: 60,
                              fontSize: 12,
                              fontWeight: 700,
                              position: 'absolute',
                              margin: '-90 0 0 20',
                              backgroundColor: 'white',
                              whiteSpace: 'nowrap'
                            }
                          : {
                              width: 'auto',
                              fontSize: 12,
                              fontWeight: 700,
                              position: 'absolute',
                              margin: '-90 0 0 20',
                              backgroundColor: 'white',
                              whiteSpace: 'nowrap'
                            }
                      }
                    ></div>
                    <Col lg={3}>
                      <Box
                        sx={{
                          height: 60,
                          margin: '20 0 0 17'
                        }}
                      >
                        <Skeleton variant='circular' width={40} height={40} />
                      </Box>
                    </Col>
                    <Col lg={2}>
                      <div style={{ cursor: 'pointer' }}>
                        <h2>
                          <Box sx={{ width: 120 }}>
                            <Skeleton />
                          </Box>
                        </h2>

                        <span
                          style={{
                            width: 'auto',
                            fontSize: 10,
                            fontWeight: 700,
                            position: 'absolute',
                            margin: '-14 0 0 0',
                            cursor: 'auto'
                          }}
                        >
                          <Box sx={{ width: 100, marginTop: 0.5 }}>
                            <Skeleton />
                          </Box>
                        </span>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div
                        style={{
                          display: 'flex',
                          marginTop: 15
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 700
                            }}
                          >
                            {value === 1 ? (
                              'DELIVERY DATE'
                            ) : (
                              <Box sx={{ width: 110 }}>
                                <Skeleton />
                              </Box>
                            )}
                            <br />
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 'normal'
                              }}
                            >
                              <Box sx={{ width: 80, marginTop: -2 }}>
                                <Skeleton />
                              </Box>
                            </span>
                          </span>
                        </div>{' '}
                        <div>
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 700,
                              margin: '0 0 0 18'
                            }}
                          >
                            {value === 1 ? (
                              'DELIVERY TIME'
                            ) : EstesApiLoading ? (
                              <Box sx={{ width: 110, marginLeft: 3 }}>
                                <Skeleton />
                              </Box>
                            ) : (
                              'EST DELIVERY TIME'
                            )}
                            <br />
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 'normal',
                                margin: '0 0 0 18'
                              }}
                            >
                              <Box
                                sx={{ width: 80, marginTop: -2, marginLeft: 3 }}
                              >
                                <Skeleton />
                              </Box>
                            </span>
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div>
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            margin: '0 0 0 18'
                          }}
                        >
                          {value === 1 ? (
                            'DELIVERY TIME'
                          ) : EstesApiLoading ? (
                            <Box sx={{ width: 110, marginLeft: 3 }}>
                              <Skeleton />
                            </Box>
                          ) : (
                            'EST DELIVERY TIME'
                          )}
                          <br />
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 'normal',
                              margin: '0 0 0 18'
                            }}
                          >
                            <Box
                              sx={{ width: 80, marginTop: -2, marginLeft: 3 }}
                            >
                              <Skeleton />
                            </Box>
                          </span>
                        </span>
                      </div>{' '}
                    </Col>
                  </Row>
                </div>
              ))
            ) : (
              <>
                {successRates
                  .filter(applyFilter)
                  .sort(applySort)
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`filter-item ${item.filterMode} p-2`}
                      style={{ width: '100%' }}
                    >
                      <Row
                        key={item.uniqueId}
                        id={item.uniqueId}
                        className={
                          selectedIndex === item.uniqueId
                            ? 'table-card active'
                            : 'table-card'
                        }
                        onClick={() =>
                          handleKanbanCardClicked(item.uniqueId, item)
                        }
                      >
                        <span className='namee d-none'>
                          {item.carrierInfo.name}
                        </span>
                        <Col
                          xs={2}
                          sm={2}
                          md={2}
                          lg={2}
                          xl={2}
                          className='d-flex flex-row h-100'
                          style={{ alignItems: 'center' }}
                        >
                          <img
                            alt=''
                            className='table-card-logo'
                            src={`${base_logo_url}carrier_logos/${item?.carrierInfo?.logo}`}
                            width={90}
                          />
                        </Col>

                        <Col
                          xs={3}
                          sm={3}
                          md={3}
                          lg={item?.carrierType === 'LTL' ? 3 : 3}
                          xl={item?.carrierType === 'LTL' ? 3 : 3}
                        >
                          <Typography
                            variant='h4'
                            className='fw-bold'
                            sx={{
                              ml: {
                                xs: -2,
                                sm: 0
                              },
                              fontSize: {
                                xs: '19px',
                                sm: '20px',
                                md: '28px',
                                lg: '34px',
                                xl: '38px'
                              }
                            }}
                          >
                            {formatePrice(item.totalNetCharge.amount)}
                          </Typography>
                          {/* {item.isGuaranteedDelviery && ( */}
                          <Typography
                            variant='body1'
                            className='text-black'
                            sx={{
                              ml: {
                                xs: -1.5,
                                sm: 0
                              },
                              fontSize: {
                                xs: '11px',
                                sm: '11px',
                                md: '11px',
                                lg: '12px',
                                xl: '13px'
                              }
                            }}
                          >
                            {/* {item.udeliveryTime === 'INVALID DATE'
                          ? ''
                          : item.udeliveryTime}{' '} */}
                            {item?.serviceType}
                            <br />
                            {item?.deliveryTime}
                          </Typography>
                          {/* )} */}
                        </Col>

                        <Col
                          xs={2}
                          sm={2}
                          md={2}
                          lg={item?.carrierType === 'LTL' ? 2 : 2}
                          xl={item?.carrierType === 'LTL' ? 2 : 2}
                        >
                          <Typography
                            variant='h4'
                            className='fw-bold'
                            style={{ textAlign: 'center' }}
                            sx={{
                              mr: {
                                xs: -4,
                                sm: 0
                              },
                              fontSize: {
                                xs: '18px',
                                sm: '20px',
                                md: '28px',
                                lg: '34px',
                                xl: '38px'
                              }
                            }}
                          >
                            <span className='dayss'>
                              {isNaN(parseInt(item.transitTime))
                                ? 'N/A'
                                : item.transitTime === '0'
                                  ? 'N/A'
                                  : parseInt(item.transitTime)}
                            </span>
                          </Typography>
                          <Typography
                            variant='body1'
                            className='text-black fw-bold'
                            style={{ textAlign: 'center' }}
                            sx={{
                              mr: {
                                xs: -4,
                                sm: 0
                              },
                              fontSize: {
                                xs: '9px',
                                sm: '10px',
                                md: '11px',
                                lg: '12px',
                                xl: '13px'
                              }
                            }}
                          >
                            Service Day(s)
                          </Typography>
                        </Col>

                        <Col
                          style={
                            item?.carrierType === 'LTL'
                              ? {
                                  textTransform: 'none',
                                  textDecoration: 'underline',
                                  fontSize: '13px'
                                }
                              : {
                                  display: 'flex',
                                  justifyContent: 'center',
                                  textTransform: 'none',
                                  textDecoration: 'underline',
                                  fontSize: '13px'
                                }
                          }
                          xs={item?.carrierType === 'LTL' ? 2 : 3}
                          sm={item?.carrierType === 'LTL' ? 2 : 3}
                          md={item?.carrierType === 'LTL' ? 2 : 3}
                          lg={item?.carrierType === 'LTL' ? 2 : 3}
                          xl={item?.carrierType === 'LTL' ? 2 : 3}
                        >
                          <Button
                            variant='text'
                            startIcon={isMdUp ? <RemoveRedEyeIcon /> : null}
                            onClick={event => handleViewRate(event, item)}
                            className='fw-bold'
                            style={{
                              textTransform: 'none',
                              textDecoration: 'underline'
                            }}
                            sx={{
                              fontSize: {
                                xs: '9px',
                                sm: '10px',
                                md: '11px',
                                lg: '12px',
                                xl: '13px'
                              }
                            }}
                          >
                            Quote Details
                          </Button>
                          {item.isThirdPartyRate &&
                            item?.carrierType !== 'LTL' && (
                              <Col
                                lg={0}
                                xl={0}
                                style={{ position: 'relative' }}
                              >
                                <Chip
                                  style={{
                                    position: 'absolute',
                                    bottom: -25,
                                    left: -90,
                                    height: 20,
                                    fontSize: 10
                                  }}
                                  label='Third Party'
                                  size='small'
                                  color='success'
                                />
                              </Col>
                            )}
                        </Col>
                        {item?.carrierType === 'LTL' ? (
                          <Col
                            xs={3}
                            sm={3}
                            md={3}
                            lg={3}
                            xl={3}
                            style={{ position: 'relative' }}
                          >
                            {/* <Button
                              variant='text'
                              startIcon={isMdUp ? <ExploreIcon /> : null}
                              onClick={event => handleViewRate1(event, item)}
                              className='fw-bold'
                              style={{
                                textTransform: 'none',
                                textDecoration: 'underline'
                              }}
                              sx={{
                                fontSize: {
                                  xs: '9px',
                                  sm: '10px',
                                  md: '11px',
                                  lg: '12px',
                                  xl: '13px'
                                }
                              }}
                            >
                              Terminal Info
                            </Button> */}
                            {item.isThirdPartyRate && (
                              <Chip
                                sx={{
                                  position: 'absolute',
                                  // width: 'auto',
                                  // maxWidth: '17vw',
                                  bottom: { xs: -15, sm: -20, md: -25 }, // Adjust position for different screen sizes
                                  left: { xs: 1, sm: 30, md: 40 }, // Adjust left position
                                  height: { xs: 16, sm: 18, md: 20 }, // Adjust height
                                  fontSize: { xs: 8, sm: 9, md: 10 }, // Adjust font size
                                  paddingX: { xs: 0.5, sm: 1 } // Adjust horizontal padding
                                }}
                                label='Third Party'
                                size='small'
                                color='success'
                              />
                            )}

                            {item.isGuaranteedDelviery ? (
                              <img
                                alt=''
                                style={{
                                  position: 'absolute',
                                  right: '2%', // Adjusts dynamically with screen size
                                  top: '-10%', // Adjusts based on container size
                                  width: '22%', // Relative to container size
                                  maxWidth: '45px', // Prevents it from getting too large
                                  height: 'auto' // Maintains aspect ratio
                                }}
                                src={GuaranteeIcon}
                              />
                            ) : null}
                          </Col>
                        ) : null}
                        {/* <Col xs={1}>

                    
                      
                    </Col> */}

                        {/* <Col>
                <Button variant="contained" startIcon={<CheckCircleIcon />} onClick={() => handleBookShipmentClicked(item)}>
                  Book Shipment
                </Button>
              </Col> */}
                      </Row>
                    </div>
                  ))}

                {checked &&
                  errorMessageApi?.map((item, index) => (
                    <div
                      className='filter-item errs  p-2'
                      style={{ width: '100%' }}
                    >
                      <Row className='table-card'>
                        <Col
                          xs={2}
                          className='d-flex flex-row h-100'
                          style={{ alignItems: 'center' }}
                        >
                          <img
                            alt=''
                            className='table-card-logo'
                            src={item?.logo?.logo}
                            width={90}
                          />
                        </Col>
                        <Col
                          className='d-flex flex-row h-100'
                          style={{ alignItems: 'center' }}
                        >
                          <RateErrorTooltip
                            title={item.message.length > 90 ? item.message : ''}
                            placement='top'
                            arrow
                            style={{
                              backgroundColor: '#c21919',
                              color: 'white'
                            }}
                          >
                            <Typography
                              variant='h6'
                              className=' text-white px-2 py-1'
                              style={{
                                fontSize: '13px',
                                backgroundColor: '#c21919',
                                borderRadius: '6px'
                              }}
                            >
                              {item.message.substring(0, 100)}
                            </Typography>
                          </RateErrorTooltip>
                        </Col>
                      </Row>
                    </div>
                  ))}
              </>
            )}
            {noActiveCarrier && (
              <Grid
                sx={{
                  mt: '20%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Alert severity='error'>
                  No active carrier found for location{' '}
                  <Link to='/view-locations'>{deepCloneObj.locationFull} </Link>
                </Alert>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default React.memo(GetShipmentRates);
